// extracted by mini-css-extract-plugin
export default {"root":"Purchase_root__fQZJG","logo":"Purchase_logo__U1SDO","form":"Purchase_form__TzevJ","pay":"Purchase_pay__Qj2i1","copyright":"Purchase_copyright__OKuy-"};